import _slicedToArray from "/Users/simonrobert/Dev/Charrette.club/LaFraise/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
export default (function () {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollPosition = _useState4[0],
      setScrollPosition = _useState4[1];

  var openMenu = function openMenu() {
    setScrollPosition(window.scrollY);
    setOpen(true);
    document.body.style.top = "-".concat(window.scrollY, "px");
    document.body.style.position = 'fixed';
    document.body.style.overflow = 'hidden';
  };

  var closeMenu = function closeMenu() {
    document.body.style.top = '0';
    document.body.style.position = 'unset';
    document.body.style.overflow = 'auto';
    setOpen(false);
    window.scrollTo(0, scrollPosition);
  }; // Close menu and unset body css position when changing page


  useEffect(function () {
    closeMenu();
    return closeMenu;
  }, []);
  return [open, openMenu, closeMenu];
});